(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-card-recipient')) {
    customElements.define(
      'gift-card-recipient',
      class GiftCardRecipient extends HTMLElement {
        connectedCallback() {
          this.toggle = this.querySelector('[data-recipient-toggle]');
          this.fields = this.querySelector('[data-recipient-fields]');
          if (!this.toggle || !this.fields) return;

          const offset = this.querySelector('[data-recipient-offset]');
          if (offset) offset.value = new Date().getTimezoneOffset().toString();

          this.toggle.addEventListener('change', () => this.sync());
          this.sync();
        }

        // Unticked: the fields are hidden and disabled, so nothing about a
        // recipient is sent and the gift card goes to the buyer as normal.
        sync() {
          const enabled = this.toggle.checked;
          this.fields.hidden = !enabled;
          this.fields.querySelectorAll('input, textarea').forEach((field) => {
            field.disabled = !enabled;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    // Shopify's <model-viewer> library and its controls are only loaded when a
  // 3D model is actually on the page.
  (() => {
    const init = () => {
      const models = document.querySelectorAll('model-viewer:not([data-model-ui])');
      if (!models.length || !window.Shopify || !Shopify.loadFeatures) return;
      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad(error) {
            if (error) return;
            models.forEach((model) => {
              model.setAttribute('data-model-ui', '');
              new Shopify.ModelViewerUI(model);
            });
          },
        },
      ]);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // The quick-add modal injects a product page after load.
    document.addEventListener('quick-add:loaded', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
